import React, { useState } from 'react';
import {
  Segment,
  Bubble,
  Col,
  Select,
  Card,
  Row,
  Button,
  Justify,
  Table,
} from 'tea-component';
import './index.scss';
import OpinionsFilter from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Opinions/components/OpinionsFilter';
import StrengthsCard from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Opinions/components/StrengthsCard';
import MentionsCard from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Opinions/components/MentionsCard';
import StoreRankingCard from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Opinions/components/StoreRankingCard';
import useData from './_hooks'
import { FilterFixed } from '@/pages/opinion/components/FilterCommon';
import { FilterGameInfoContext } from '@/pages/opinion/components/FilterCommon/context';

export default function Overview(props) {
  const {
    onConfirm,
    param,
    radarItemArr,
    radarLabelArr,
    topictabList,
    filterResult,
    loadingNew,
    topicMentions,
    sentimentStacked,
    entityType,
    userId,
    gameId
  } = useData(props)

  return (
    <>
      {
        (props.filterResult["channel"] && param) ? (
          <>
            <FilterGameInfoContext.Provider
              value={{
                use: true,
                gameInfo: { edition_unified_id: gameId, entity_type: entityType, id_type: 'unified_id' },
              }}
            >
              <FilterFixed
                filter={[
                  'date',
                  'regionAndLanguage',
                  'channel',
                ]}
                confirm={(value) => {
                  // console.log("confirm", value)
                  onConfirm(value)
                }}
                operateShowOptions={null}
              />
            </FilterGameInfoContext.Provider>
            <StrengthsCard 
              loadingNew={loadingNew}
              radarItemArr={radarItemArr}
              radarLabelArr={radarLabelArr}
              topictabList={{...topictabList}}
              filterAll={filterResult}
            />
            <MentionsCard
              topictabList={{...topictabList}}
              loadingNew={loadingNew}
              topicMentions={topicMentions}
              sentimentStacked={sentimentStacked}
              gameType={entityType}
            />
            <StoreRankingCard 
              filter={param}
              userId={userId}
              gameInfo={props}
            />
          </>
        ) :(
          <div/>
        )
      }
    </>
  );
}
